import React, { useContext } from 'react'
import { ProfilesStyles } from './Style'
import { ProfilesContext } from './ProfilesContext'
import { Chip } from 'components/Form'
import { abilityGroups } from 'keys'
import { useSelector } from 'react-redux'
import { map } from 'lodash'

const Profiles = () => {
    const { brokenDisplay } = useSelector(state => state.general)

    const { profiles: profilesRes, visibleRatings, showDetails } = useContext(ProfilesContext)

    const profiles = profilesRes.data

    const checkTypes = map(abilityGroups)

    return (
        <ProfilesStyles>
            {checkTypes.map((checkType) =>
                <div className='profile-section'>
                    <div className='profile-header'>
                        <div className='profile-title'>
                            {checkType.icon}
                            {checkType.label}
                        </div>
                    </div>

                    <div className='profile-content-cards overflow'>
                        {Object.entries(profiles || {}).map(([profileKey, profileData]) =>
                            visibleRatings[profileKey] && profileData?.[checkType.key].students?.length > 0 &&
                            <div>
                                <div className='profile-content-cards overflow'>
                                    {profileData?.[checkType.key].students?.map((student) =>
                                        visibleRatings[profileKey] &&
                                        <div className={`profile-content-card-item ${brokenDisplay ? 'blurred2' : ''}`}>
                                            <Chip color={`rating${profileKey}`}>
                                                {student.name}
                                                {showDetails && `, ${student.school_class}`}
                                            </Chip>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </ProfilesStyles>
    )
}

export default Profiles